<div class="break-wrapper">
  <div class="title">
    {{ 'Break' | translate }}
    </div>
  <div class="break-clock">
    @if(getClock(clockName.SET_BREAK) && getClock(clockName.SET_BREAK)?.timePipe === 'ss'){
         <span class="time-colan">:</span> 
        }
        <app-stopwatch 
            #setBreakClock
            [showButtons]="false"
            [match]="match"
            [clockInputValue]="getClock(clockName.SET_BREAK)" 
            [displayType]="'INTENNSE_VIEW'"
      ></app-stopwatch>
  </div>
      <ion-buttons class="timeout-btns">
        <ion-button color="dark" class="undo-btn"  expand="block" (click)="dismissModal()">CLOSE</ion-button>
        <ion-button color="light" class="end-btn" expand="block" id="open-custom-dialog">END</ion-button>
    </ion-buttons>
</div>


<ion-modal id="confirm-modal" trigger="open-custom-dialog" #customModal>
  <ng-template>
    <div class="wrapper">
      <h3>End Break Clock?</h3>
      <ion-buttons class="confirm-btns">
          <ion-button (click)="customModal.dismiss()">No</ion-button>
          <ion-button id="open-custom-dialog" expand="block" (click)="endBreak()">Yes</ion-button>
      </ion-buttons>
    </div>
  </ng-template>
</ion-modal>


<ion-modal id="confirm-modal" trigger="open-undo-dialog" #undoModal>
    <ng-template>
      <div class="wrapper">
        <h3>Undo Break?</h3>
        <ion-buttons class="confirm-btns">
            <ion-button (click)="undoModal.dismiss()">No</ion-button>
            <ion-button id="open-undo-dialog" expand="block" (click)="undoBreak()">Yes</ion-button>
        </ion-buttons>
      </div>
    </ng-template>
</ion-modal>